/* AdiBody - Scelta consegna nel carrello: "Consegna a domicilio" / "Ritiro in ufficio postale".
   Salva negli attributi del carrello (-> ordine Shopify): Consegna, Ufficio postale, _Ufficio postale codice (codice Poste).
   La finestra con l'elenco degli uffici e in ab-uffici.js.
   16/10/2026: "Consegna a domicilio" e GIA SELEZIONATA se il cliente non sceglie niente (il checkout non si blocca piu). */
(function () {
  if (window.__abConsegna) return;
  window.__abConsegna = true;

  /* Uffici che Spedisci NON accetta (controllo del 16/10/2026: per ogni CAP Spedisci accetta al massimo 5 uffici).
     Li tolgo dall'elenco mostrato nel carrello (ab-uffici.js) cosi la cliente non puo sceglierli. */
  var ESCLUSI = {};
  '01001,01006,01064,01126,01223,01260,01261,01310,01387,01389,04126,05013,06126,06135,07011,07145,09117,09129,10011,12112,12140,12168,12234,13214,14002,14045,14079,14081,15189,16050,16124,16155,17018,17041,17053,17054,17062,17107,17110,18067,18155,19133,19254,19255,19261,20050,20342,21170,21244,21283,21293,21300,24069,24072,24107,26109,26110,26111,27025,27052,27074,27095,27164,27172,27184,29023,29047,31168,31204,31212,31227,33022,33064,33094,33201,35123,35124,37063,37081,38125,38149,38198,40086,40388,42122,43010,43041,43055,43057,43109,45086,45167,45183,46081,46126,46183,46197,46198,46205,46310,46381,46457,47070,47103,51148,51156,55339,55364,55533,55632,55854,55881,55883,57005,58147,58149,58151,58159,58172,59086,59125,60030,62099,63248,64005,64048,64077,65077,65106,65158,65170,65198,66029,66215,66405,66427,68031,69018,69172,69190,69195,69196,72080,74128,74161,74426,79033,79042,79051,81001,83107,83111,88019,88210,88231,88233,89135,89254,89266,89275,89285'.split(',').forEach(function (c) { ESCLUSI[c] = 1; });
  if (window.fetch && !window.__abFiltroUffici) {
    window.__abFiltroUffici = true;
    var fetchOriginale = window.fetch;
    window.fetch = function (url) {
      var p = fetchOriginale.apply(window, arguments);
      if (typeof url !== 'string' || !window.abUfficiUrl || url !== window.abUfficiUrl) return p;
      return p.then(function (r) {
        if (!r.ok) return r;
        return r.json().then(function (d) {
          d.uffici = (d.uffici || []).filter(function (x) { return !ESCLUSI[String(x[0])]; });
          return new Response(JSON.stringify(d), { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      });
    };
  }

  var DOMICILIO = 'A domicilio';
  var RITIRO = 'Ritiro in ufficio postale';

  var stato = { modo: '', ufficio: '' };

  /* ---------------- utilità ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function salva(attributi) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributi })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  /* ---------------- blocco nel carrello ---------------- */
  function disegnaBlocco(box) {
    var ritiro = stato.modo === RITIRO;
    box.innerHTML =
      '<p class="ab-consegna__titolo">Come vuoi ricevere il pacco?</p>' +
      '<div class="ab-consegna__opzioni" role="radiogroup" aria-label="Modalità di consegna">' +
      '<button type="button" role="radio" class="ab-consegna__opzione" data-ab-modo="domicilio" aria-checked="' + (stato.modo === DOMICILIO) + '">' +
      '<span class="ab-consegna__icona" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M10 21v-6h4v6"/></svg>' +
      '</span><span><strong>Consegna a domicilio</strong><small>Al tuo indirizzo</small><em class="ab-consegna__gratis" style="display:block;margin-top:3px;font-style:normal;font-size:1.05rem;font-weight:700;letter-spacing:.06em;color:#b9804f">GRATUITA</em></span></button>' +
      '<button type="button" role="radio" class="ab-consegna__opzione" data-ab-modo="ritiro" aria-checked="' + ritiro + '">' +
      '<span class="ab-consegna__icona" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>' +
      '</span><span><strong>Ritiro in ufficio postale</strong><small>Se non sei a casa</small><em class="ab-consegna__gratis" style="display:block;margin-top:3px;font-style:normal;font-size:1.05rem;font-weight:700;letter-spacing:.06em;color:#b9804f">GRATUITO</em></span></button>' +
      '</div>' +
      (ritiro
        ? stato.ufficio
          ? '<div class="ab-consegna__scelto"><span>Ritirerai presso<br><strong>' + esc(stato.ufficio) + '</strong></span>' +
            '<button type="button" class="ab-consegna__link" data-ab-apri>Cambia</button></div>' +
            '<p class="ab-consegna__nota">Al checkout inserisci comunque nome, indirizzo e telefono: servono per contattarti. Il pagamento alla consegna è disponibile anche in ufficio postale.</p>'
          : ''
        : '') +
      '<p class="ab-consegna__errore" hidden></p>';
  }
  function aggiornaTutti() {
    document.querySelectorAll('[data-ab-consegna]').forEach(disegnaBlocco);
  }
  // stato salvato nel carrello (scritto da Liquid nella sezione ab-consegna)
  var iniziale = window.abConsegnaStato || {};
  stato.modo = iniziale.modo || '';
  stato.ufficio = iniziale.ufficio || '';
  // la scelta resta solo mentre il cliente sta navigando: dopo 30 minuti senza aprire il sito si azzera,
  // cosi chi torna dopo non trova una scelta vecchia preselezionata (e non compra per sbaglio con il ritiro)
  var CHIAVE = 'abConsegnaScelta', DURATA = 30 * 60 * 1000;
  function sceltaRecente() {
    try { var t = +localStorage.getItem(CHIAVE); return !!t && Date.now() - t < DURATA; } catch (e) { return true; }
  }
  function segnaScelta() {
    try { localStorage.setItem(CHIAVE, String(Date.now())); } catch (e) {}
  }
  if ((stato.modo || stato.ufficio) && !sceltaRecente()) {
    stato.modo = '';
    stato.ufficio = '';
    salva({ Consegna: '', 'Ufficio postale': '', '_Ufficio postale codice': '', '_Ufficio postale coordinate': '' }).catch(function () {});
  } else if (stato.modo) {
    segnaScelta(); // sta ancora navigando: i 30 minuti ripartono
  }
  // nessuna scelta: domicilio gia selezionato (solo a video; l'ordine senza attributo e comunque a domicilio)
  if (!stato.modo) stato.modo = DOMICILIO;
  function errore(testo) {
    document.querySelectorAll('[data-ab-consegna] .ab-consegna__errore').forEach(function (p) {
      p.textContent = testo || '';
      p.hidden = !testo;
    });
  }

  function scegliModo(modo) {
    errore('');
    segnaScelta();
    if (modo === 'domicilio') {
      stato.modo = DOMICILIO;
      stato.ufficio = '';
      aggiornaTutti();
      salva({ Consegna: DOMICILIO, 'Ufficio postale': '', '_Ufficio postale codice': '', '_Ufficio postale coordinate': '' }).catch(function () {
        errore('Non siamo riusciti a salvare la scelta. Riprova.');
      });
    } else {
      stato.modo = RITIRO;
      aggiornaTutti();
      if (!stato.ufficio) apriModale();
      salva({ Consegna: RITIRO }).catch(function () {
        errore('Non siamo riusciti a salvare la scelta. Riprova.');
      });
    }
  }

  function apriModale() {
    vistaRicerca();
    if (window.abUffici) window.abUffici.apri(scegliUfficio);
  }

  /* 22/10/2026: dopo "Ritira qui" la finestra resta aperta e mostra l'ufficio scelto,
     l'avviso "Attenzione" e il pulsante "Prosegui con l'ordine" (va al checkout). */
  var ultimoSalvataggio = null;
  function finestra() { return document.querySelector('.ab-uffici'); }
  function vistaRicerca() {
    var m = finestra();
    if (!m) return;
    var c = m.querySelector('.ab-uffici__conferma');
    if (c) c.remove();
    ['.ab-uffici__cerca', '.ab-uffici__posizione', '.ab-uffici__corpo'].forEach(function (s) {
      var x = m.querySelector(s);
      if (x) x.style.display = '';
    });
  }
  function mostraConferma(u) {
    var m = finestra();
    if (!m) return;
    vistaRicerca();
    ['.ab-uffici__cerca', '.ab-uffici__posizione', '.ab-uffici__corpo'].forEach(function (s) {
      var x = m.querySelector(s);
      if (x) x.style.display = 'none';
    });
    var box = document.createElement('div');
    box.className = 'ab-uffici__conferma';
    box.style.cssText = 'padding:4px 0 6px;text-align:left';
    box.innerHTML =
      '<div style="padding:12px 14px;border:2px solid #b9804f;background:#fff;border-radius:12px;font-size:1.4rem;line-height:1.45">' +
      '<span style="display:block;font-size:1.25rem;opacity:.75">✓ Ritirerai presso</span>' +
      '<strong style="display:block;font-size:1.5rem">' + esc(u.nome) + '</strong>' +
      '<span style="display:block">' + esc(u.indirizzo || '') + '</span></div>' +
      '<div role="note" style="margin:12px 0;padding:10px 12px;border:2px solid #d97706;background:#fff7ed;border-radius:10px;color:#000;font-size:1.35rem;line-height:1.45">' +
      '<strong style="display:block;font-size:1.5rem;margin-bottom:3px;color:#b45309">⚠️ Attenzione</strong>' +
      'Dopo aver cliccato <strong>«Prosegui con l\'ordine»</strong> inserisci comunque nome, cognome, indirizzo e telefono: servono per contattarti. Il pagamento alla consegna è disponibile anche in ufficio postale.</div>' +
      '<button type="button" data-ab-prosegui style="display:block;width:100%;padding:15px 12px;border:0;border-radius:10px;background:#1a1a1a;color:#fff;font-size:1.5rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;cursor:pointer">Prosegui con l\'ordine</button>' +
      '<button type="button" data-ab-cambia style="display:block;margin:12px auto 0;background:none;border:0;color:#b9804f;font-size:1.35rem;font-weight:600;text-decoration:underline;cursor:pointer">Cambia ufficio</button>';
    var sotto = m.querySelector('.ab-uffici__corpo');
    sotto.parentNode.insertBefore(box, sotto);
    box.querySelector('[data-ab-cambia]').addEventListener('click', function () { vistaRicerca(); });
    box.querySelector('[data-ab-prosegui]').addEventListener('click', function () {
      var b = this;
      b.disabled = true;
      b.textContent = 'Attendi…';
      Promise.resolve(ultimoSalvataggio).catch(function () {}).then(function () { window.location.href = '/checkout'; });
    });
    m.hidden = false;
    document.documentElement.classList.add('ab-uffici-aperto');
  }
  function scegliUfficio(u) {
    if (!u) return;
    segnaScelta();
    var testo = u.nome + (u.indirizzo ? ' – ' + u.indirizzo : '');
    stato.modo = RITIRO;
    stato.ufficio = testo;
    aggiornaTutti();
    mostraConferma(u);
    ultimoSalvataggio = salva({
      Consegna: RITIRO,
      'Ufficio postale': testo + (u.codice ? ' (cod. ' + u.codice + ')' : ''),
      '_Ufficio postale codice': u.codice || '',
      '_Ufficio postale coordinate': Number(u.lat).toFixed(6) + ',' + Number(u.lon).toFixed(6)
    }).catch(function () {
      errore('Non siamo riusciti a salvare l\'ufficio scelto. Riprova.');
    });
  }

  /* ---------------- eventi ---------------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-ab-consegna] [data-ab-modo]');
    if (m) return scegliModo(m.getAttribute('data-ab-modo'));
    if (e.target.closest('[data-ab-consegna] [data-ab-apri]')) return apriModale();

    // se ha scelto il ritiro ma non l'ufficio, chiedo l'ufficio prima del checkout
    var checkout = e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    if (checkout && stato.modo === RITIRO && !stato.ufficio) {
      e.preventDefault();
      e.stopImmediatePropagation();
      errore('Scegli l\'ufficio postale dove vuoi ritirare il pacco, oppure seleziona la consegna a domicilio.');
      apriModale();
    }
  }, true);

  // metto il blocco sopra ogni pulsante "Procedi all'ordine" (carrello laterale e pagina carrello).
  // Il carrello laterale si ridisegna a ogni modifica: lo rimetto ogni volta.
  function scansiona() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prima = ctas.previousElementSibling;
      if (prima && prima.hasAttribute('data-ab-consegna')) return;
      var vuoto = ctas.querySelector('button[name="checkout"][disabled]');
      if (vuoto) return;
      var box = document.createElement('div');
      box.className = 'ab-consegna';
      box.setAttribute('data-ab-consegna', '');
      ctas.parentNode.insertBefore(box, ctas);
      disegnaBlocco(box);
    });
  }
  new MutationObserver(scansiona).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scansiona);
  else scansiona();
})();
